/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

/* ============= Footer Acordion =============  */
const footerLinkMenu = document.querySelectorAll("button.footer__item-title");
function footerToggle() {
  const content = this.nextElementSibling;
  this.classList.toggle("is-active");
  content.classList.toggle("is-open");
}

for (let i = 0; i < footerLinkMenu.length; i++) {
  footerLinkMenu[i].addEventListener("click", footerToggle);
}

/* ============= MegaMenu Control =============  */
document.addEventListener("DOMContentLoaded", () => {
  const headerWrapper = document.querySelector(".header__wrapper");
  const megaMenus = document.querySelectorAll(".mega-menu");

  if (!headerWrapper || megaMenus.length === 0) return;

  const updateHeaderState = () => {
    const anyOpen = Array.from(megaMenus).some(menu => !menu.hasAttribute("hidden"));
    headerWrapper.classList.toggle("header__wrapper--mega-open", anyOpen);
  };

  const observer = new MutationObserver(updateHeaderState);

  megaMenus.forEach(menu => {
    observer.observe(menu, {
      attributes: true,
      attributeFilter: ["hidden"]
    });
  });
  updateHeaderState();
});

/* ============= Page Top =============  */
document.addEventListener("DOMContentLoaded", () => {
  const pageTopBtn = document.getElementById("js-page-top");
  if (!pageTopBtn) return;
  const SHOW_OFFSET = 200;
  const toggleVisibility = () => {
    if (window.scrollY > SHOW_OFFSET) {
      pageTopBtn.classList.add("is-visible");
    } else {
      pageTopBtn.classList.remove("is-visible");
    }
  };
  pageTopBtn.addEventListener("click", () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  });
  window.addEventListener("scroll", toggleVisibility, { passive: true });
  toggleVisibility();
});

/* ============= Custom Acordion =============  */
/* イベント委譲: 再描画後に追加された .c-acordion__toggle も動作する */
document.addEventListener("click", function (e) {
  var toggleEl = e.target.closest(".c-acordion__toggle");
  if (!toggleEl) return;
  var content = toggleEl.nextElementSibling;
  if (!content) return;
  toggleEl.classList.toggle("is-active");
  content.classList.toggle("is-open");
});

/* ============= Custom Tab =============  */
/* イベント委譲: DOMContentLoaded 後に追加・再描画された .c-tab も動作する */
document.addEventListener('click', function (e) {
  var tab = e.target.closest('.c-tab');
  if (!tab) return;
  var ancestorEle = tab.closest('.c-tab-panel');
  if (!ancestorEle) return;

  var activeEls = ancestorEle.getElementsByClassName('is-active');
  if (activeEls.length) activeEls[0].classList.remove('is-active');
  tab.classList.add('is-active');

  var showEls = ancestorEle.getElementsByClassName('is-show');
  if (showEls.length) showEls[0].classList.remove('is-show');

  var groupTabs = ancestorEle.getElementsByClassName('c-tab');
  var arrayTabs = Array.prototype.slice.call(groupTabs);
  var index = arrayTabs.indexOf(tab);
  var panels = ancestorEle.getElementsByClassName('c-panel');
  if (index >= 0 && panels[index]) {
    panels[index].classList.add('is-show');
  }
});



/* ============= Custom Drawer =============  */
(function() {
  'use strict';
  if (customElements.get('custom-drawer')) {
    return;
  }
  class CustomDrawer extends HTMLElement {
    constructor() {
      super();
      this._listenersAttached = false;
    }
    connectedCallback() {
      if (this._listenersAttached) {
        return;
      }
      const overlay = this.querySelector('.drawer__overlay');
      const closeButton = this.querySelector('.drawer__close-button');     
      if (overlay) {
        overlay.addEventListener('click', () => {
          this.open = false;
        });
      }      
      if (closeButton) {
        closeButton.addEventListener('click', () => {
          this.open = false;
        });
      }
      this._listenersAttached = true;
    }
    disconnectedCallback() {     
      this._listenersAttached = false;
    }
    static get observedAttributes() {
      return ['open'];
    }
    get open() {
      return this.hasAttribute('open');
    }
    set open(value) {
      if (value) {
        this.setAttribute('open', '');
      } else {
        this.removeAttribute('open');
      }
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (oldValue === newValue) {
        return;
      }

      if (name === 'open') {
        if (newValue !== null) {
          const toggle = this.id ? document.querySelector(`[aria-controls="${this.id}"]`) : null;
          if (toggle) {
            toggle.setAttribute('aria-expanded', 'true');
            if (!toggle.classList.contains('c-drawer-toggle--nolock')) {
              if (!document.documentElement.classList.contains('lock-all')) {
                document.documentElement.classList.add('lock-all');
              }
            }
          } else {
            const parent = this.parentElement;
            if (parent) {
              const prevToggle = this.previousElementSibling;
              if (prevToggle && prevToggle.classList.contains('c-drawer-toggle')) {
                if (!prevToggle.classList.contains('c-drawer-toggle--nolock')) {
                  if (!document.documentElement.classList.contains('lock-all')) {
                    document.documentElement.classList.add('lock-all');
                  }
                }
              }
            }
          }
        } else {
          const toggle = this.id ? document.querySelector(`[aria-controls="${this.id}"]`) : null;
          if (toggle) {
            toggle.setAttribute('aria-expanded', 'false');
          }
          const otherOpenDrawers = document.querySelectorAll('custom-drawer[open]');
          let hasLockDrawer = false;
          otherOpenDrawers.forEach(drawer => {
            const drawerId = drawer.id;
            if (drawerId) {
              const drawerToggle = document.querySelector(`[aria-controls="${drawerId}"]`);
              if (drawerToggle && !drawerToggle.classList.contains('c-drawer-toggle--nolock')) {
                hasLockDrawer = true;
              }
            }
          });
          
          if (!hasLockDrawer) {
            const themeDrawers = document.querySelectorAll('drawer-content[open]');
            if (themeDrawers.length === 0) {
              document.documentElement.classList.remove('lock-all');
            }
          }
        }
      }
    }
  }

  customElements.define('custom-drawer', CustomDrawer);

  document.addEventListener('click', function (event) {
    const toggle = event.target.closest('.c-drawer-toggle');
    if (!toggle) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    const drawerId = toggle.getAttribute('aria-controls');
    if (drawerId) {
      const drawer = document.getElementById(drawerId);
      if (drawer && drawer.tagName.toLowerCase() === 'custom-drawer') {
        drawer.open = !drawer.open;
        return;
      }
    }
    if (!drawerId) {
      const drawer = toggle.nextElementSibling;
      if (drawer && drawer.tagName.toLowerCase() === 'custom-drawer') {
        drawer.open = !drawer.open;
      }
    }
  }, { passive: false });
})();

/* ============= 商品一覧ページでカラー変更時に価格切り替え =============  */
if (document.querySelector('.jsColorPriceVaries')) {    
  document.addEventListener('change', (e) => {    
    const radio = e.target.closest('.color-swatch__radio');
    if (!radio) return;

    const swatchList = radio.closest('.product-item-meta__swatch-list.jsColorPriceVaries');
    if (!swatchList) return;

    const productRoot = swatchList.closest('.product-item');
    const priceEl = productRoot?.querySelector('.jsPriceVaries');
    if (!priceEl) return; 

    const productId = productRoot.dataset.productId;
    if (!productId) return;

    const color = radio.value;
    const colorData = window.colorPrices?.[productId]?.[color];
    if (!colorData) return;

    const { price, compare_at_price } = colorData;
    
    if (compare_at_price > price) {
      priceEl.innerHTML = `      
      <span class="price price--compare">¥${compare_at_price.toLocaleString()}</span>
        <span class="price price--highlight">¥${price.toLocaleString()}</span>        
      `;
    } else {
      priceEl.innerHTML = `<span class="price">¥${price.toLocaleString()}</div>`;
    }
  });

}


/* ============= Product Mobile Filter Show Control =============  */
(() => {
  'use strict';

  const SELECTOR = {
    target: '.product-facet__meta-bar-filter',
    footer: '.footer',
  };

  const CONFIG = {
    maxWidth: 740,
    scrollThreshold: 200,
  };

  const initMetaBarVisibility = () => {
    const update = () => {
      // 毎回要素を再取得して、親要素が再描画されても動作するようにする
      const target = document.querySelector(SELECTOR.target);
      const footer = document.querySelector(SELECTOR.footer);

      if (!target || !footer) return;

      if (window.innerWidth > CONFIG.maxWidth) {
        target.classList.remove('is-visible');
        return;
      }

      const scrolledEnough = window.scrollY > CONFIG.scrollThreshold;

      const footerRect = footer.getBoundingClientRect();
      const footerVisible = footerRect.top < window.innerHeight;

      if (scrolledEnough && !footerVisible) {
        target.classList.add('is-visible');
      } else {
        target.classList.remove('is-visible');
      }
    };

    update();

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMetaBarVisibility, { once: true });
  } else {
    initMetaBarVisibility();
  }
})();

/* ============= Custom Variant Form =============  */
(function() {
    const attachedButtons = new WeakSet();
    let closeHandler = null;
    let overlayHandler = null;
    let originalParent = null;
    let originalNextSibling = null;

    function initMobileVariantForm() {      
      const jsMobileVariantFormButtons = document.querySelectorAll('.jsMobileVariantFormButton');
      jsMobileVariantFormButtons.forEach(button => {
        if (attachedButtons.has(button)) return;        
        button.addEventListener('click', function() {
          const modal = document.querySelector(".c-modal-form--mobile-form");
          const mobileForm = document.querySelector(".c-product-form__mobile");
          if (modal) {
            // .c-product-form__mobileをbodyの直下に移動
            if (mobileForm && mobileForm.parentNode !== document.body) {
              // 元の位置を保存
              originalParent = mobileForm.parentNode;
              originalNextSibling = mobileForm.nextSibling;
              document.body.appendChild(mobileForm);
            }
            // is-openクラスを追加
            if (mobileForm) {
              mobileForm.classList.add("is-open");
            }
            modal.setAttribute("open", "true");
            document.documentElement.classList.add("lock-all");
          }
        });
        attachedButtons.add(button);
      });

      function popupClose_MobileVariantForm() {
        const modal = document.querySelector(".c-modal-form--mobile-form");
        const mobileForm = document.querySelector(".c-product-form__mobile");
        if (modal) {
          modal.setAttribute("open", "false");
          document.documentElement.classList.remove("lock-all");
          // is-openクラスを削除
          if (mobileForm) {
            mobileForm.classList.remove("is-open");
          }
          // .c-product-form__mobileを元の位置に戻す
          if (mobileForm && originalParent) {
            if (originalNextSibling) {
              originalParent.insertBefore(mobileForm, originalNextSibling);
            } else {
              originalParent.appendChild(mobileForm);
            }
            originalParent = null;
            originalNextSibling = null;
          }
        }
      }

      const closeIcon = document.querySelector(".c-modal-form--mobile-form .c-modal-form__close");
      if (closeIcon) {
        if (closeHandler) {
          closeIcon.removeEventListener("click", closeHandler);
        }
        closeHandler = popupClose_MobileVariantForm;
        closeIcon.addEventListener("click", closeHandler);
      }

      const closeButton = document.querySelector(".c-modal-form--mobile-form .c-modal-form__close-button");
      if (closeButton) {
        if (closeHandler) {
          closeButton.removeEventListener("click", closeHandler);
        }
        closeHandler = popupClose_MobileVariantForm;
        closeButton.addEventListener("click", closeHandler);
      }

      const overlay = document.querySelector(".c-modal-form--mobile-form .c-modal-form__overlay");
      if (overlay) {
        if (overlayHandler) {
          overlay.removeEventListener("click", overlayHandler);
        }
        overlayHandler = popupClose_MobileVariantForm;
        overlay.addEventListener("click", overlayHandler);
      }
    }
    
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", initMobileVariantForm);
    } else {
      initMobileVariantForm();
    }

    const mutationObserver = new MutationObserver((mutations) => {
      let shouldReinit = false;
      
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            if (node.classList?.contains("jsMobileVariantFormButton") ||
                node.classList?.contains("c-modal-form--mobile-form") ||
                node.querySelector?.(".jsMobileVariantFormButton") ||
                node.querySelector?.(".c-modal-form--mobile-form")) {
              shouldReinit = true;
            }
          }
        });
      });

      if (shouldReinit) {
        setTimeout(initMobileVariantForm, 100);
      }
    });

    mutationObserver.observe(document.body || document.documentElement, {
      childList: true,
      subtree: true
    });
  })();

/* ============= Custom Mobile Menu Drawer Control =============  */
(function() {
  'use strict';

  function updateCustomMobileMenuState(isOpen) {
    const customMobileMenu = document.querySelector('.c-mobile-menu');
    const headerWrapper = document.querySelector('.header__wrapper');
    const toggleButton = document.querySelector('[aria-controls="custom-mobile-menu-drawer"]');

    if (!customMobileMenu || !headerWrapper) {
      return;
    }

    if (isOpen) {
      // 開く
      headerWrapper.classList.add('is-open');
      document.documentElement.classList.add('lock-all');
      customMobileMenu.style.display = 'block';
    } else {
      // 閉じる
      headerWrapper.classList.remove('is-open');
      document.documentElement.classList.remove('lock-all');
      customMobileMenu.style.display = 'none';
    }
  }

  function initCustomMobileMenu() {
    const toggleButton = document.querySelector('[aria-controls="custom-mobile-menu-drawer"]');
    const customMobileMenu = document.querySelector('.c-mobile-menu');
    const headerWrapper = document.querySelector('.header__wrapper');

    if (!toggleButton || !customMobileMenu || !headerWrapper) {
      return;
    }

    // 既にイベントリスナーが追加されているかチェック
    if (toggleButton.dataset.listenerAttached === 'true') {
      return;
    }

    // クリックイベントをリッスン
    toggleButton.addEventListener('click', function(e) {
      // 少し遅延させてaria-expandedの変更を待つ
      setTimeout(function() {
        const isExpanded = toggleButton.getAttribute('aria-expanded') === 'true';
        updateCustomMobileMenuState(isExpanded);
      }, 10);
    });

    // aria-expanded属性の変更を監視（toggle-buttonが自動的に変更する場合に備えて）
    const attributeObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'aria-expanded') {
          const isExpanded = toggleButton.getAttribute('aria-expanded') === 'true';
          updateCustomMobileMenuState(isExpanded);
        }
      });
    });

    attributeObserver.observe(toggleButton, {
      attributes: true,
      attributeFilter: ['aria-expanded']
    });

    // フラグを設定して重複追加を防ぐ
    toggleButton.dataset.listenerAttached = 'true';

    // オーバーレイクリックで閉じる処理
    const headerOverlay = headerWrapper.querySelector('.header__overlay');
    if (headerOverlay) {
      headerOverlay.addEventListener('click', function() {
        toggleButton.setAttribute('aria-expanded', 'false');
        updateCustomMobileMenuState(false);
      });
    }

    // オーバーレイや閉じるボタンで閉じる処理
    const closeButtons = customMobileMenu.querySelectorAll('[data-action="close"], .c-mobile-menu__close');
    closeButtons.forEach(function(closeBtn) {
      closeBtn.addEventListener('click', function() {
        toggleButton.setAttribute('aria-expanded', 'false');
        updateCustomMobileMenuState(false);
      });
    });

    // 初期状態を設定
    const initialExpanded = toggleButton.getAttribute('aria-expanded') === 'true';
    updateCustomMobileMenuState(initialExpanded);
  }

  // DOMContentLoaded時または即座に実行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomMobileMenu);
  } else {
    initCustomMobileMenu();
  }

  // 動的に追加される要素に対応するためMutationObserverを使用
  const observer = new MutationObserver(function(mutations) {
    let shouldReinit = false;
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) {
          if (node.matches && node.matches('[aria-controls="custom-mobile-menu-drawer"]')) {
            shouldReinit = true;
          } else if (node.querySelector && node.querySelector('[aria-controls="custom-mobile-menu-drawer"]')) {
            shouldReinit = true;
          }
        }
      });
    });
    if (shouldReinit) {
      setTimeout(initCustomMobileMenu, 100);
    }
  });

  observer.observe(document.body || document.documentElement, {
    childList: true,
    subtree: true
  });
})();

/* ============= Custom Mobile Menu Navigation =============  */
(function() {
  'use strict';

  function initMobileMenuNavigation() {
    const mobileMenu = document.querySelector('.c-mobile-menu');
    if (!mobileMenu) {
      return;
    }

    // 既にイベントリスナーが追加されているかチェック
    if (mobileMenu.dataset.navigationInitialized === 'true') {
      return;
    }

    // メニューアイテムのクリックイベント
    mobileMenu.addEventListener('click', function(e) {
      const menuLink = e.target.closest('.c-mobile-menu__link--has-children');
      if (menuLink) {
        e.preventDefault();
        const menuItem = menuLink.getAttribute('data-menu-item');
        const currentLevel = menuLink.closest('.c-mobile-menu__level');
        const currentLevelNum = parseInt(currentLevel.getAttribute('data-level'));
        const nextLevelNum = currentLevelNum + 1;
        
        // 現在のレベルを非表示
        currentLevel.classList.remove('is-active');
        currentLevel.style.display = 'none';
        
        // 次のレベルを表示
        const nextLevel = mobileMenu.querySelector(`.c-mobile-menu__level--${nextLevelNum}[data-parent="${menuItem}"]`);
        if (nextLevel) {
          nextLevel.style.display = 'block';
          setTimeout(function() {
            nextLevel.classList.add('is-active');
          }, 10);
        }
      }
    });

    // 戻るボタンのクリックイベント
    mobileMenu.addEventListener('click', function(e) {
      const backButton = e.target.closest('.c-mobile-menu__back');
      if (backButton) {
        e.preventDefault();
        const backToLevel = backButton.getAttribute('data-back-to');
        const backParent = backButton.getAttribute('data-back-parent');
        const currentLevel = backButton.closest('.c-mobile-menu__level');
        const currentLevelNum = parseInt(currentLevel.getAttribute('data-level'));
        
        // 現在のレベルを非表示
        currentLevel.classList.remove('is-active');
        setTimeout(function() {
          currentLevel.style.display = 'none';
        }, 300);
        
        // 前のレベルを表示
        if (backToLevel === '1') {
          const firstLevel = mobileMenu.querySelector('.c-mobile-menu__level--1');
          if (firstLevel) {
            firstLevel.style.display = 'block';
            setTimeout(function() {
              firstLevel.classList.add('is-active');
            }, 10);
          }
        } else if (backToLevel === '2' && backParent) {
          const secondLevel = mobileMenu.querySelector(`.c-mobile-menu__level--2[data-parent="${backParent}"]`);
          if (secondLevel) {
            secondLevel.style.display = 'block';
            setTimeout(function() {
              secondLevel.classList.add('is-active');
            }, 10);
          }
        }
      }
    });

    // 初期状態で1階層目を表示
    const firstLevel = mobileMenu.querySelector('.c-mobile-menu__level--1');
    if (firstLevel) {
      firstLevel.style.display = 'block';
      firstLevel.classList.add('is-active');
    }

    // フラグを設定
    mobileMenu.dataset.navigationInitialized = 'true';
  }

  // DOMContentLoaded時または即座に実行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileMenuNavigation);
  } else {
    initMobileMenuNavigation();
  }

  // モーダルが開かれたときに再初期化
  const headerWrapper = document.querySelector('.header__wrapper');
  if (headerWrapper) {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          if (headerWrapper.classList.contains('is-open')) {
            setTimeout(initMobileMenuNavigation, 100);
          } else {
            // モーダルが閉じられたときに1階層目にリセット
            const mobileMenu = document.querySelector('.c-mobile-menu');
            if (mobileMenu) {
              const allLevels = mobileMenu.querySelectorAll('.c-mobile-menu__level');
              allLevels.forEach(function(level) {
                level.classList.remove('is-active');
                level.style.display = 'none';
              });
              const firstLevel = mobileMenu.querySelector('.c-mobile-menu__level--1');
              if (firstLevel) {
                firstLevel.style.display = 'block';
                firstLevel.classList.add('is-active');
              }
            }
          }
        }
      });
    });

    observer.observe(headerWrapper, {
      attributes: true,
      attributeFilter: ['class']
    });
  }
})();



/* ============= Custom FAQ =============  */
(function() {
  const faqItems = document.querySelectorAll('.c-faq__item');
  
  faqItems.forEach(function(item) {
    const question = item.querySelector('.c-faq__question');
    const answer = item.querySelector('.c-faq__answer');
    const toggle = item.querySelector('.c-faq__toggle');
    
    if (question && answer && toggle) {
      question.addEventListener('click', function() {
        const isActive = item.classList.contains('c-faq__item--active');
        
        if (isActive) {
          item.classList.remove('c-faq__item--active');
          answer.classList.remove('c-faq__answer--open');
          toggle.setAttribute('aria-expanded', 'false');
        } else {
          item.classList.add('c-faq__item--active');
          setTimeout(function() {
            answer.classList.add('c-faq__answer--open');
          }, 10);
          toggle.setAttribute('aria-expanded', 'true');
        }
      });
    }
  });
})();


/* ============= Rich Text read more =============  */
(function() {
  const WRAPPER_SEL = '.content-box__description--read-more';
  const INNER_SEL = '.content-box__description-inner';
  const BUTTON_SEL = '.content-box__read-more';

  function updateOverflow(wrapper) {
    const inner = wrapper.querySelector(INNER_SEL);
    const button = wrapper.querySelector(BUTTON_SEL);
    if (!inner || !button || wrapper.classList.contains('is-expanded')) return;
    button.hidden = inner.scrollHeight <= inner.clientHeight + 1;
  }

  function init(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(WRAPPER_SEL).forEach(updateOverflow);
  }

  document.addEventListener('click', function(event) {
    const button = event.target.closest(BUTTON_SEL);
    if (!button) return;
    const wrapper = button.closest(WRAPPER_SEL);
    if (!wrapper) return;
    const expanded = wrapper.classList.toggle('is-expanded');
    button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    const expandText = button.getAttribute('data-expand-text') || 'View more';
    const collapseText = button.getAttribute('data-collapse-text') || 'Close';
    button.textContent = expanded ? collapseText : expandText;
    if (!expanded) updateOverflow(wrapper);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { init(); });
  } else {
    init();
  }

  window.addEventListener('resize', function() { init(); });
  document.addEventListener('shopify:section:load', function(event) { init(event.target); });
})();